module.exports = __webpack_public_path__ + "static/media/switch-img.cb8f7d48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Reports/Timps/Switch/switch-img.jpg
// module id = 1635
// module chunks = 0